import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { DelegatesService } from '../../services/delegates.service';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmDelegateRemovalComponent } from 'src/app/components/confirm-delegate-removal/confirm-delegate-removal.component';
import { catchError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmDelegateCreationComponent } from 'src/app/components/confirm-delegate-creation/confirm-delegate-creation.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { HandlerSnackbarService } from 'src/app/services/handler-snackbar.service';

@Component({
  selector: 'app-delegates',
  templateUrl: './delegates.component.html',
  styleUrls: ['./delegates.component.scss'],
})
export class DelegatesComponent implements OnInit {
  faTrash = faTrash;
  displayedColumnsDelegates: string[] = [
    'id',
    'firstName',
    'lastName',
    'email',
    'delete',
  ];
  delegatesDataSource: any;

  tab: string = 'delegates';

  @ViewChild(MatSort) sortdelegates = new MatSort();

  constructor(
    private readonly modalService: NgbModal,
    private readonly cdRef: ChangeDetectorRef,
    private readonly delegatesService: DelegatesService,
    private readonly alertService: HandlerSnackbarService,
    private readonly spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.spinnerService.open();
    this.getAllDelegates();
    this.initSort();
    this.spinnerService.close();
  }

  getAllDelegates() {
    this.delegatesService.getDelegates().subscribe((data: any) => {
      this.delegatesDataSource = new MatTableDataSource(data);
      this.delegatesDataSource.sort = this.sortdelegates;
      console.log(data);
    });
  }

  initSort() {
    this.cdRef.detectChanges();
    if (this.delegatesDataSource)
      this.delegatesDataSource.sort = this.sortdelegates;
    this.cdRef.detectChanges();
  }

  tabChange(selTab: string) {
    this.tab = selTab;
    this.initSort();
  }

  createDelegateModal() {
    const modalRef = this.modalService.open(ConfirmDelegateCreationComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.alertService.viewUserMessage(
            'Operazione in corso...',
            'withdraw-snackbar'
          );
          this.delegatesService
            .addDelegate(result.id)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.alertService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              this.getAllDelegates();
              this.alertService.viewUserClosingMessage(
                'Delegato aggiunto con successo',
                'success-snackbar'
              );
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  removeDelegateModal(element: any) {
    const modalRef = this.modalService.open(ConfirmDelegateRemovalComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.alertService.viewUserMessage(
            'Operazione in corso...',
            'withdraw-snackbar'
          );
          this.delegatesService
            .removeDelegate(result.id)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.alertService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              this.getAllDelegates();
              this.alertService.viewUserClosingMessage(
                'Delegato rimosso con successo',
                'success-snackbar'
              );
            });
        }
      },
      (error) => {
        console.log(error);
        this.alertService.viewUserClosingMessage(
          error.error.error.message || error.message,
          'error-snackbar'
        );
      }
    );

    modalRef.componentInstance.info = element;
  }
}
